/*!
  Atom, by Koding Themes
  navigation.js
  https://kodingthemes.com
*/

var asideMain = document.querySelector('#aside_main').innerHTML;

document.addEventListener("DOMContentLoaded", function () {
  sidebarNavigationLoad();
  sideNavigationOtherMethods();
});

window.addEventListener("resize", function () {
  if(document.querySelector('.sidebar-menu') != null){
    document.querySelector('.sidebar-menu').remove();
    var asideMainUpdated = document.querySelector('#aside_main');
    asideMainUpdated.innerHTML = asideMain;
  }
  setTimeout(function(){
    sidebarNavigationLoad();
    sideNavigationOtherMethods();
  },100);
});

function sidebarNavigationLoad() {
    var listItemsParent = document.querySelectorAll(
    ".sidebar-menu-list-parent li a"
  );
  var listItemsChild = document.querySelectorAll(".sidebar-menu-list-child li a");

  if (listItemsParent != null) {
    sidebarNavigationExecute(listItemsParent);
  }
  if (listItemsChild != null) {
    sidebarNavigationExecute(listItemsChild);
  }
}

function hideOtherLists(lists) {
  lists.forEach(function (list, i) {
    list.style.display = "none";
  });
}

function sidebarNavigationExecute(listItems) {
  listItems.forEach(function (e, i) {
    if (window.innerWidth > 1023) {
      e.onmouseover = function () {
        sidebarNavigationMain(listItems, e);
      };
    } else {
      e.onclick = function () {
        sidebarNavigationMain(listItems, e);
      };
    }
    var ele = e.closest("li").querySelector("span.dropdown-toggle");
    if (ele != null) {
      if (window.innerWidth > 1023) {
        // ele.onmouseover = function () {
        //   sidebarNavigationMain(listItems, e);
        // };
      } else {
        ele.onclick = function () {
          sidebarNavigationMain(listItems, e);
        };
      }
    }
  });
}

function sidebarNavigationMain(listItems, e) {
  var listChild = document.querySelectorAll(".sidebar-menu-list-child");
  var listGrandChild = document.querySelectorAll(".sidebar-menu-list-grandchild");
  listItems.forEach((e) =>
    e.closest("li").classList.remove("active-sidebar-menu-item")
  );
  e.closest("li").classList.add("active-sidebar-menu-item");
  var nextColumnItems = e.dataset.nextcolumn;
  if (e.closest(".sidebar-menu-list-parent") && listChild != null) {
    if (listGrandChild != null) {
      document.querySelector(".sidebar-menu-columns-grandchild").style.width =
        "0%";
      document
        .querySelector(".sidebar-menu-columns-grandchild")
        .classList.remove("active-sidebar-nav-column");
      hideOtherLists(listGrandChild);
    }

    if (nextColumnItems != undefined) {
      hideOtherLists(listChild);
      var nextColList = document.querySelector("." + nextColumnItems);
      nextColList.style.display = "block";
      document.querySelector(".sidebar-menu-columns-child").style.width =
        "100%";
      document
        .querySelector(".sidebar-menu-columns-child")
        .classList.add("active-sidebar-nav-column");
      var navListSelector = ".sidebar-menu-list-child li";
      // animateNavigtaionList(navListSelector);
      //console.log(nextColumnItems);
    } else {
      document.querySelector(".sidebar-menu-columns-child").style.width = "0%";
      document
        .querySelector(".sidebar-menu-columns-child")
        .classList.remove("active-sidebar-nav-column");
      hideOtherLists(listChild);
    }
  } else if (e.closest(".sidebar-menu-list-child") && listGrandChild != null) {
    if (nextColumnItems != undefined) {
      hideOtherLists(listGrandChild);
      var nextColList = document.querySelector("." + nextColumnItems);
      nextColList.style.display = "block";
      document.querySelector(".sidebar-menu-columns-grandchild").style.width =
        "100%";
      document
        .querySelector(".sidebar-menu-columns-grandchild")
        .classList.add("active-sidebar-nav-column");
      var navListSelector = ".sidebar-menu-list-grandchild li";
      // animateNavigtaionList(navListSelector);
      console.log(nextColumnItems);
    } else {
      document.querySelector(".sidebar-menu-columns-grandchild").style.width =
        "0%";
      document
        .querySelector(".sidebar-menu-columns-grandchild")
        .classList.remove("active-sidebar-nav-column");
      hideOtherLists(listGrandChild);
    }
  }
}
var close = document.querySelector(".close-menu-hamburger");
if(close != null) {
  close.onclick = function (e) {
    sidebarNavigationClose();
  };
}

document.onclick = function (e) {
  var target = e.target;
  if (target.closest(".sidebar-menu-columns") == null) {
    sidebarNavigationClose();
  }
};

function sidebarNavigationClose() {
   var listItemsParent = document.querySelectorAll(
    ".sidebar-menu-list-parent li a"
  );
  var listItemsChild = document.querySelectorAll(".sidebar-menu-list-child li a");

  if (listItemsParent != null) {
    listItemsParent.forEach((e) =>
      e.closest("li").classList.remove("active-sidebar-menu-item")
    );
  }
  if (listItemsChild != null) {
    listItemsChild.forEach((e) =>
      e.closest("li").classList.remove("active-sidebar-menu-item")
    );
  }
  if (document.querySelectorAll(".sidebar-menu-list-child") != null) {
    document.querySelector(".sidebar-menu-columns-child").style.width = "0%";
    document
      .querySelector(".sidebar-menu-columns-child")
      .classList.remove("active-sidebar-nav-column");
    document
      .querySelectorAll(".sidebar-menu-list-child")
      .forEach((e) => (e.style.display = "none"));
  }
  if (document.querySelectorAll(".sidebar-menu-list-grandchild") != null) {
    document.querySelector(".sidebar-menu-columns-grandchild").style.width =
      "0%";
    document
      .querySelector(".sidebar-menu-columns-grandchild")
      .classList.remove("active-sidebar-nav-column");
    document
      .querySelectorAll(".sidebar-menu-list-grandchild")
      .forEach((e) => (e.style.display = "none"));
  }
}

//animation for menu items
function animateNavigtaionList(navListSelector) {
  gsap.set(navListSelector, { x: -110, opacity: 0 });
  var tl = gsap.timeline();
  tl.to(
    navListSelector,
    { duration: 0.4, opacity: 1, x: 0, ease: Sine.easeOut, stagger: 0.2 }, 0.2
  );
}

// additional methods
function sideNavigationOtherMethods(){

var open = document.querySelector('.open-menu-hamburger');
  if (open != null) {
    open.onclick = function (e) {
      console.log('open'); //createOverlay();

      keepMenuOpen(); // animateNavigtaionListParent();
    };
  }

  var mobileMenu = document.querySelector('.js-menu-toggle-mobile');
  if (mobileMenu != null) {
    mobileMenu.onclick = function (e) {
      createOverlay();
      keepMenuOpen(); // animateNavigtaionListParent();
    };
  } //keep menu open when clicking inside sidebar

  if (document.querySelector('.sidebar-menu') != null) {
    document.querySelector('.sidebar-menu').onclick = function (e) {
      document.body.removeEventListener('click', closeSidebar);
      keepMenuOpen(); //createOverlay();

      var target = e.target;

      if (target.closest('.sidebar-menu-columns') == null) {
        keepMenuClosed();
      }
    };
  } //close sidebar when clicked on overlay

  // js for back button
  var back = document.querySelectorAll(".sidebar-menu-back");
  if (back != null) {
    back.forEach(function (btn, index) {
      btn.onclick = function () {
        var step = btn.dataset.menuback;
        var currentCol = btn.closest(".sidebar-menu-columns");
        if (currentCol != null) {
          if (step == "parent") {
            //gsap.set(".sidebar-menu-list-child li", { opacity: 0 });
          } else if (step == "child") {
            //gsap.set(".sidebar-menu-list-grandchild li", { opacity: 0 });
          }
          currentCol.classList.remove("active-sidebar-nav-column");
          currentCol.style.width = "0%";
        }
      };
    });
  }
}
var closeSidebar = function closeSidebar(e) {
  passive: true;

  var container = document.querySelector(".sidebar-menu");
  var $body = document.body;
  if(container != null){
    if (!(container.classList[0] === e.target.classList[0]) && container.querySelector(e.target.classList[0]) == null) {
      if ($body.classList.contains('show-sidebar-main')) {
        keepMenuClosed();
      }
    }
  }
}; //invoke event listeners

var keepMenuOpen = function keepMenuOpen() {
  if (!document.body.classList.contains('show-sidebar-main')) {
    if (Shopify.designMode != true) {
      document.querySelector('#aside_main').style.transform = 'translate(0px, '+window.pageYOffset+'px)';
    }
      document.body.classList.add('show-sidebar-main');
      document.body.classList.add('active');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.querySelector('.left-side').classList.remove('border-right');
      var fullMenu = document.querySelector('.sidebar-menu-full-width');
      fullMenu.classList.remove('hidden');
      console.log('Menu opened and gasp running');
    }
  }; //close mobile menu

  var keepMenuClosed = function keepMenuClosed() {
    if (document.body.classList.contains('show-sidebar-main')) {
      document.body.classList.remove('show-sidebar-main');
      document.body.classList.remove('active');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.querySelector('.left-side').style.background = 'transparent';
      document.querySelector('.left-side').classList.add('border-right');
      var menuOverlay = document.querySelector('.menu-popup-background');
      var fullMenu = document.querySelector('.sidebar-menu-full-width');
      fullMenu.classList.add('hidden');

      if (menuOverlay) {
        menuOverlay.remove();
      }

      console.log('Menu closed');
    }
  }; //create menu overlay

  var createOverlay = function createOverlay() {
    var is_exists = document.querySelector('.menu-popup-background');

    if (is_exists != null) {
      is_exists.remove();
    }

    var sidebarOverlay = document.createElement('div');
    sidebarOverlay.classList.add('menu-popup-background');
    document.getElementsByTagName('body')[0].appendChild(sidebarOverlay);
    console.log('Overlay created');
  };

  var animateNavigtaionListParent = function animateNavigtaionListParent() {
    if (document.querySelectorAll('.sidebar-menu-list-parent li') != null) {
      var navListSelector = '.sidebar-menu-list-parent li';
      gsap.set(navListSelector, {
        x: -110,
        opacity: 0
      });
      var tl = gsap.timeline();
      tl.to(navListSelector, {
        duration: 0.4,
        opacity: 1,
        x: 0,
        ease: Sine.easeOut,
        stagger: 0.2
      }, 0.2);
    }
  }; //when hamburger icons is clicked
